import React, { Component } from "react";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { withTranslation } from "react-i18next";
import { Trans } from "react-i18next";
import { Draggable } from "react-beautiful-dnd";
import "@mdi/font/css/materialdesignicons.min.css";

const styles = (theme) => ({});

export class EditLayoutElement extends Component {
  state = {};

  render() {
    const { classes, t } = this.props;
    return (
      <Draggable
        draggableId={this.props.layout.id.toString()}
        index={this.props.index}
      >
        {(dragProvided, dragSnapshot) => (
          <div
            style={{ margin: "8px" }}
            ref={dragProvided.innerRef}
            {...dragProvided.draggableProps}
          >
            <Card
              style={{ margin: "8px", minWidth: "200px" }}
              // ref={dragProvided.innerRef}
              // {...dragProvided.draggableProps}
              // {...dragProvided.dragHandleProps}
            >
              <CardHeader
                avatar={
                  <span
                    className="mdi mdi-drag-vertical"
                    style={{ fontSize: "1.5rem" }}
                    {...dragProvided.dragHandleProps}
                  />
                }
                title={
                  <TextField
                    aria-label={"edit-title-" + this.props.index}
                    className={classes.textField}
                    onChange={(e) =>
                      this.props.changeLabel(
                        e.target.value,
                        this.props.layout.id
                      )
                    }
                    value={this.props.layout.title}
                    label={t("global_document_title")}
                  />
                }
              />
            </Card>
          </div>
        )}
      </Draggable>
    );
  }
}

export default withStyles(styles)(withTranslation()(EditLayoutElement));
